<template>
  <div>
    <!-- error snackbar -->
    <v-snackbar
      v-if="error_title != 'server_busy'"
      v-model="error_show"
      top
      text
      color="error"
      elevation="3"
      class="mt-6"
      timeout="-1"
    >
      <div class="d-flex flex-row align-center">
        <v-icon left color="error">mdi-alert</v-icon>
        {{ message }}
        <v-btn
          icon
          @click="
            $store.dispatch('change_server_busy_state', false);
            $router.go(0);
          "
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click="$store.dispatch('change_server_busy_state', false)"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <div v-if="additional_information != ''">
        <v-divider style="border-color: #ff00001f" class="my-3" />
        <p class="ml-8">{{ additional_information }}</p>
      </div>
    </v-snackbar>

    <!-- timeout / delay snackbar -->
    <v-snackbar
      v-else
      v-model="error_show"
      top
      text
      color="info"
      elevation="3"
      class="mt-6"
      timeout="6000"
    >
      <div class="d-flex flex-row align-center">
        <v-icon left color="info">mdi-tortoise</v-icon>
        {{ additional_information }}
        <v-btn
          icon
          @click="
            $store.dispatch('change_server_busy_state', false);
            $router.go(0);
          "
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click="$store.dispatch('change_server_busy_state', false)"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <div v-if="additional_information != ''">
        <div class="mt-5 mb-3" style="width: 89%; margin: auto">
          <v-progress-linear
            color="info darken-2"
            stream
            reverse
            value="0"
            buffer-value="0"
          ></v-progress-linear>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "error_dialog",
  data() {
    return {};
  },

  computed: {
    additional_information() {
      return this.$store.state.error_handler.msg;
    },

    // a computed getter
    message: function () {
      let return_message =
        "Ups… Es ist etwas schiefgelaufen. Bitte versuchen Sie es jetzt oder zu einem späteren Zeitpunkt erneut.";

      if (this.error_title == "Token has expired") {
        return_message =
          "Sie wurden automatisch ausgeloggt. Bitte loggen Sie sich erneut ein.";
      } else if (this.error_title == "Not enough segments") {
        return_message =
          "Der Dialog wurde bereits beendet. Daher ist ein Dialog aktuell nicht mehr möglich.";
      } else if (this.error_title == "Dialog ist nicht mehr aktiv.") {
        return_message =
          "Der Dialog wurde bereits beendet. Daher ist ein Dialog aktuell nicht mehr möglich.";
      }

      // `this` points to the vm instance
      return return_message;
    },
  },

  props: {
    error_show: {
      type: Boolean,
    },
    error_title: {
      type: String,
    },
    error_msg: {
      type: String,
    },
  },
};
</script>

<style scoped>
.infotext {
  line-height: 1.3;
  font-size: 0.875em;
}

.hoverEffect {
  transition: 0.5s ease;
}

.errorStyle {
  background-color: rgba(255, 255, 255, 1);
}
</style>
